import type { HeaderBlock } from "../types"

// Section heading. Always full-bleed across all breakpoints — there's no
// reason to reflow a one-line title.
export function HeaderBlockView({ block }: { block: HeaderBlock }) {
  return (
    <div className="space-y-0.5">
      <h3 className="text-sm font-semibold uppercase tracking-wide text-app-text">{block.text}</h3>
      {block.subtitle && (
        <p className="text-xs text-app-muted">{block.subtitle}</p>
      )}
    </div>
  )
}
